<div class="resource-day-map-modal-overlay" (click)="close()">
  <div class="resource-day-map-modal" (click)="$event.stopPropagation()">
    <div class="resource-day-map-modal-header">
      <h3 class="resource-day-map-modal-title">
        {{ team?.label || team?.name || 'Resource' }} – {{ day?.date?.format('DD.MM.YYYY') }}
      </h3>
      <button type="button" class="resource-day-map-modal-close" (click)="close()" title="Schließen">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="resource-day-map-modal-body row">
      <div class="col-8 resource-day-map-col">
        <div class="resource-day-map-geocode-prompt" *ngIf="showGeocodePrompt">
          <p class="resource-day-map-geocode-prompt-text">
            Für {{ eventsNeedingGeocodeCount }} Termin(e) sind keine Koordinaten hinterlegt. Sollen die Koordinaten ermittelt werden?
          </p>
          <div class="resource-day-map-geocode-prompt-actions">
            <button type="button" class="btn btn-primary btn-sm" (click)="confirmLoadCoords()">
              <i class="fa fa-map-marker"></i> Koordinaten ermitteln
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="declineLoadCoords()">
              Nein
            </button>
          </div>
        </div>
        <div class="resource-day-map-geocoding-hint" *ngIf="geocodingInProgress">
          <i class="fa fa-spinner fa-spin"></i> {{ geocodingMessage }}
        </div>
        <agm-map
          class="resource-day-map"
          [latitude]="mapLat"
          [longitude]="mapLng"
          [zoom]="mapZoom"
          [zoomControl]="true"
          [scrollwheel]="true">
          <agm-marker
            *ngFor="let item of allEventsWithCoords; let i = index"
            [latitude]="item.lat"
            [longitude]="item.lng"
            [label]="(i + 1).toString()">
          </agm-marker>
        </agm-map>
      </div>
      <div class="col-4 resource-day-list-col">
        <h5 class="resource-day-list-title">Termine</h5>
        <div class="resource-day-list" *ngIf="events?.length > 0">
          <div class="resource-day-list-item" *ngFor="let event of events; let i = index">
            <span class="resource-day-list-num">{{ i + 1 }}.</span>
            <span class="resource-day-list-time">{{ getEventTimeDisplay(event) }}</span>
            <span class="resource-day-list-title-text">{{ event.title }}</span>
            <span class="resource-day-list-address" *ngIf="event.data?.postal_code || event.data?.street">
              {{ event.data?.postal_code }} {{ event.data?.place || '' }} {{ event.data?.street || '' }}
            </span>
          </div>
        </div>
        <p class="resource-day-list-empty text-muted" *ngIf="!events?.length">Keine Termine an diesem Tag.</p>
      </div>
    </div>
  </div>
</div>
